import { useCallback, useEffect, useState } from 'react';

export const useShowMoreItems = ({
  initialCount,
  showMoreCount,
}: {
  initialCount: number;
  showMoreCount: number;
}) => {
  const [itemCount, setItemCount] = useState(initialCount);

  useEffect(() => setItemCount(initialCount), [initialCount]);

  const loadMoreItems = useCallback(() => {
    setItemCount((prev) => prev + showMoreCount);
  }, [showMoreCount]);

  const showLessItems = useCallback(
    (initial = false) => {
      setItemCount((prev) => (initial ? initialCount : prev - showMoreCount));
    },
    [initialCount, showMoreCount],
  );

  return {
    itemCount,
    loadMoreItems,
    showLessItems,
  };
};
